import type { UserInfoResponse } from '@/chat-types/model/user/UserInfoResponse';
import * as SC from '@/components/channelList/UserChipItem.style';
import Chips from '@/components/common/chips/Chips';
import Icon from '@/components/common/Icon';

type ChipItemProps = {
  user: UserInfoResponse;
  index: number;
  onClickDelete: (user: UserInfoResponse) => void;
};

const UserChipItem = ({ user, index, onClickDelete }: ChipItemProps) => {
  return (
    <SC.Container title={user.userName}>
      <Chips key={`chips__${user.userId}${index}`} targetId={user.userId}>
        <Chips.Label label={user.userName} className='user-selected-label' />
        <Chips.Icon
          onClick={() => {
            onClickDelete(user);
          }}
        >
          <Icon icon='IcDelete' size='16px' />
        </Chips.Icon>
      </Chips>
    </SC.Container>
  );
};

export default UserChipItem;
